/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import {
  Button,
  Divider,
  mergeClasses,
} from '@fluentui/react-components';
import { VideoRegular } from '@fluentui/react-icons';

import { useStyles } from './style';

// TODO -Move to common place, let's not import ads-studio component here.
const getClosestAspectRatio = (width, height) => {
  const inputRatio = width / height;
  const ratios = {
    '16:9': (16 / 9),
    '9:16': (9 / 16),
    '4:3': (4 / 3),
    '1:1': (1 / 1),
    '9:21': (9 / 21),
    '21:9': (21 / 9),
    '3:4': (3 / 4),
  };
  let closestRatio = null;
  let closestDiff = Math.abs(inputRatio - closestRatio);

  /* eslint-disable no-restricted-syntax */
  for (const [label, ratio] of Object.entries(ratios)) {
    const diff = Math.abs(inputRatio - ratio);
    if (diff < closestDiff) {
      closestDiff = diff;
      closestRatio = label;
    }
  }

  return closestRatio;
};

export const VideoTemplateSummaryBarControl = ({
  i18n,
  setShowPreviewVideoModal,
  onSaveVideo,
  metadata,
  activity,
}) => {
  const classes = useStyles();
  const [summaryBar, setSummaryBar] = useState(null);

  const aspectRatio = useMemo(() => {
    const template = metadata && metadata.template;
    if (template && template.width > 0 && template.height > 0) {
      return getClosestAspectRatio(template.width, template.height);
    }
    return null;
  }, [metadata]);


  /* istanbul ignore next */
  const preview = useCallback(() => {
    setShowPreviewVideoModal(true);
    if (activity && activity.signal) {
      const message = `[VideoAdsEditor] - Edit Video - Preview - TemplateId:${metadata && metadata.template && metadata.template.templateId}, AdStudio:true`;
      activity.signal(message);
    }
  }, [setShowPreviewVideoModal, activity, metadata]);

  /* istanbul ignore next */
  const publish = useCallback(() => {
    onSaveVideo();
  }, [onSaveVideo]);

  /* istanbul ignore next */
  const customizedContent = useMemo(() => (
    <div className={mergeClasses('edit-video-page-summary-bar', classes.container)} >
      {aspectRatio && (
        <>
          <div className={mergeClasses('aspect-ratio', classes.aspectRatio)}>
            {aspectRatio}
          </div>
          <Divider className={mergeClasses('divider', classes.divider)} vertical />
        </>
      )
      }
      <Button
        icon={<VideoRegular />}
        appearance="secondary"
        className={mergeClasses('preview-button', classes.previewButton)}
        disabled={false}
        onClick={preview}
      >
        {i18n.getString(_TL_('Preview video'))}
      </Button>
      <Button
        appearance="primary"
        className={mergeClasses('publish-button', classes.previewButton)}
        disabled={false}
        onClick={publish}
      >
        {i18n.getString(_TL_('Save to Ads Studio'))}
      </Button>

    </div>
  ), [classes, i18n, preview, publish, aspectRatio]);

  /* istanbul ignore next */
  useEffect(() => {
    const timer = setInterval(() => {
      try {
        const summaryBarCustomizeEle = document.getElementById('ad-studio-summary-bar-customize-container');
        if (summaryBarCustomizeEle) {
          setSummaryBar(summaryBarCustomizeEle);
          clearInterval(timer);
        }
      } catch (error) {
        clearInterval(timer);
      }
    }, 500);
    return () => clearInterval(timer);
  }, []);

  return (
    summaryBar ? createPortal(
      customizedContent,
      summaryBar
    ) : null
  );
};

VideoTemplateSummaryBarControl.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  setShowPreviewVideoModal: PropTypes.func.isRequired,
  logger: PropTypes.shape({
    log: PropTypes.func,
  }).isRequired,
  metadata: PropTypes.shape({}).isRequired,
};
